import { useState, useRef } from 'react';
import axios from 'axios';
import { Upload, X, ImageIcon } from 'lucide-react';
import { toast } from 'sonner';
import { resolveImgUrl } from '@/utils/imgUrl';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ImageUpload({ value, onChange, label = 'Foto', className = '' }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error('Maksimal 5MB'); return; }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const { data } = await axios.post(`${API}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      // Simpan path relatif (/api/files/...) agar tidak terikat domain preview tertentu
      onChange(data.url);
      toast.success('Foto berhasil diunggah');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal mengunggah foto');
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const previewSrc = resolveImgUrl(value);

  return (
    <div className={className}>
      {label && <label className="block text-xs font-semibold text-gray-600 mb-1.5">{label}</label>}
      <div className="flex items-center gap-3">
        {/* Preview */}
        <div className="w-16 h-16 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center flex-shrink-0 border border-gray-200">
          {previewSrc ? (
            <img src={previewSrc} alt="" className="w-full h-full object-cover" />
          ) : (
            <ImageIcon size={24} className="text-gray-300" />
          )}
        </div>
        <div className="flex-1">
          <button type="button" onClick={() => inputRef.current?.click()}
            disabled={uploading}
            className="flex items-center gap-1.5 text-xs font-semibold text-emerald-600 bg-emerald-50 hover:bg-emerald-100 px-3 py-2 rounded-xl transition-colors disabled:opacity-60">
            {uploading ? (
              <div className="w-3 h-3 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
            ) : <Upload size={14} />}
            {uploading ? 'Mengunggah...' : 'Upload Foto'}
          </button>
          {value && (
            <button type="button" onClick={() => onChange('')}
              className="mt-1.5 flex items-center gap-1 text-xs text-red-400 hover:text-red-500">
              <X size={12} /> Hapus foto
            </button>
          )}
          <p className="text-[10px] text-gray-400 mt-1">JPG, PNG, WebP · Maks 5MB</p>
        </div>
      </div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
    </div>
  );
}
